import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56249ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " 別列車から時刻表をコピーしてきます。時間をずらせます。パターンダイヤを組むのに便利です。 ", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" コピー先: ")
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "formgrid grid" }
const _hoisted_5 = { class: "field col-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "train-from" }, "コピー元", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "field col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "offset" }, "オフセット(分)", -1))
const _hoisted_10 = { class: "field col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "offset-to" }, "ずらす向き", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "別の列車からコピー",
    modal: true,
    dismissableMask: true,
    visible: _ctx.localVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localVisible) = $event)),
    onShow: _ctx.initialize,
    class: "dttmcfot-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "確定",
        onClick: _ctx.onClick
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", null, [
        _hoisted_2,
        _createElementVNode("span", {
          style: _normalizeStyle({ color: _ctx.diagramDataSet.borderColor }),
          class: "font-bold"
        }, "■", 4),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.diagramDataSet.label), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            id: "train-from",
            class: "inputfield w-full input",
            modelValue: _ctx.selectedTrainFromTrain,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTrainFromTrain) = $event)),
            options: 
            _ctx.diagramDataSets.filter(
              (v) => v.id !== _ctx.diagramDataSet.id && v.data.length
            )
          ,
            optionLabel: "label",
            placeholder: "コピー元を選ぶ",
            filter: true
          }, {
            value: _withCtx((slotProps) => [
              (slotProps.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: slotProps.value.borderColor })
                    }, "■", 4),
                    _createElementVNode("span", null, _toDisplayString(slotProps.value.label), 1),
                    _createTextVNode(" / " + _toDisplayString(slotProps.value.data[0].name) + " " + _toDisplayString(_ctx.formatDdHhmmToHhmm(slotProps.value.data[0].time)) + "発 ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            option: _withCtx((slotProps) => [
              _createElementVNode("span", {
                style: _normalizeStyle({ color: slotProps.option.borderColor })
              }, "■", 4),
              _createElementVNode("span", null, _toDisplayString(slotProps.option.label), 1),
              _createTextVNode(" / " + _toDisplayString(slotProps.option.data[0].name) + " " + _toDisplayString(_ctx.formatDdHhmmToHhmm(slotProps.option.data[0].time)) + "発 ", 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputNumber, {
            id: "offset",
            class: "inputfield w-full input",
            modelValue: _ctx.offset,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.offset) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Dropdown, {
            id: "offset-to",
            class: "inputfield w-full input",
            modelValue: _ctx.selectedDirection,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDirection) = $event)),
            options: _ctx.directions,
            optionLabel: "name"
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onShow"]))
}